import { ColorMode } from "../types";
import ColorLegends from "./ColorLegends";

const BubbleChartLegends = ({ colorMode, showCenterMarker }: {
  colorMode: ColorMode,
  // Show the Cluster Weighted Average (diamond) legend entry.
  showCenterMarker?: boolean,
}) => {
  return (
    <>
      <ColorLegends colorMode={colorMode} showCenterMarker={showCenterMarker} />

      <div className="flex items-center justify-between text-neutral-400 font-medium text-xs">
        <div>Volume vs Difficulty  •  Size = Ranking  •  Color = Trend</div>
        <div>Bubble Size: Larger bubbles = Better rankings (closer to position 1)</div>
      </div>
    </>
  )
}

export default BubbleChartLegends;